import React from 'react';

export const SnapshotInfoIcon: React.FC<sharedComponents.SvgIcon> = ({ height = 24, width = 24, className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} width={width} height={height} fill="none">
    <path d="M11 1.25c5.4 0 9.75 4.35 9.75 9.75S16.4 20.75 11 20.75A9.73 9.73 0 0 1 1.25 11c0-5.4 4.35-9.75 9.75-9.75Zm0-.75C5.225.5.5 5.225.5 11S5.225 21.5 11 21.5 21.5 16.775 21.5 11 16.775.5 11 .5Z" fill="#4C4C4C"/>
    <path d="M11 7.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z" fill="#4C4C4C"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M11 8.75c.207 0 .375.168.375.375v6.75a.375.375 0 0 1-.75 0v-6.75c0-.207.168-.375.375-.375Z" fill="#000"/>
  </svg>
);
